import { resourceUrls } from "../../../config";
import _get from "lodash/get";
import _head from "lodash/head";
import axios from "axios";

const leftUniversity = studyingStatus =>
    studyingStatus !== "Currently studying";

export const submitDetails = async ({
    values: {
        firstName,
        lastName,
        emailPrefix,
        emailExtension,
        personalEmail,
        universityId,
        hasAccessToUniEmail,
        password,
    },
    studyingStatus,
}) => {
    const details = {
        firstName,
        lastName,
        email: !hasAccessToUniEmail
            ? personalEmail
            : `${emailPrefix}${emailExtension}`,
        personalEmail,
        universityId,
        hasAccessToUniEmail,
        password,
        leftUniversity: leftUniversity(studyingStatus),
    };

    const signupResponse = await axios
        .post(resourceUrls.signup.submit, details)
        .then(response => ({
            error: !(response.status >= 200 && response.status < 400),
            status: response.status,
            data: response.data,
        }))
        .catch(function (error) {
            if (error.response) {
              return {
                        error: true,
                        status: error.response.status,
                        data: error.response.data
              };
            } else {
              return { error: true, status: undefined, data: {} };
            }
          });

    return signupResponse;
};

export const exposeCookies = async () => {
    return await axios
        .post(resourceUrls.cookies.expose)
        .then(response => ({
            error: !(response.status >= 200 && response.status < 400),
        }))
        .catch(() => ({ error: true }));
};

export const fetchUniversityNames = async setUniversityNames => {
    const universityNames = await axios
        .get(resourceUrls.signup.getUniversityNames)
        .then(response => ({
            error: !(response.status >= 200 && response.status < 400),
            data: response.data,
        }))
        .catch(() => ({ error: true, data: [] }));

    return setUniversityNames(universityNames.data);
};

export const fetchEmailDomains = universityName => async ({
    setFieldValue,
    setEmailDomains,
}) => {
    const emailExtensions = await axios
        .get(resourceUrls.signup.getUniversity(universityName))
        .then(response => ({
            error: !(response.status >= 200 && response.status < 400),
            data: response.data,
        }))
        .catch(() => ({ error: true, data: [] }));

    const { emailExtension = "", id = undefined } = _head(
        _get(emailExtensions, "data", [])
    );

    if (emailExtensions.data.length < 2) {
        setFieldValue("emailExtension", emailExtension);
        setFieldValue("universityId", id);
    } else {
        setFieldValue("universityId", id);
        setFieldValue("emailExtension", "");
    }

    return setEmailDomains(emailExtensions.data);
};
